import { render, staticRenderFns } from "./Restaurants.vue?vue&type=template&id=754520ff&scoped=true&"
import script from "./Restaurants.vue?vue&type=script&lang=js&"
export * from "./Restaurants.vue?vue&type=script&lang=js&"
import style0 from "./Restaurants.vue?vue&type=style&index=0&id=754520ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754520ff",
  null
  
)

export default component.exports